module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v("\n          " + _vm._s(_vm.redirects.length + (_vm.redirects.length === 1 ? ' redirect' : ' redirects')) + "\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new redirect")])]), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-redirect-from"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirect.fromUrl),
      expression: "newRedirect.fromUrl"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-redirect-from"
    },
    domProps: {
      "value": (_vm.newRedirect.fromUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirect, "fromUrl", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-redirect-to"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirect.toUrl),
      expression: "newRedirect.toUrl"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-redirect-to"
    },
    domProps: {
      "value": (_vm.newRedirect.toUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirect, "toUrl", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createRedirect()
      }
    }
  }, [_vm._v("Create redirect")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    staticClass: "categories-list-body__head"
  }, [_c('tr', [_c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFrom),
      expression: "searchFrom"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "From ..."
    },
    domProps: {
      "value": (_vm.searchFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTo),
      expression: "searchTo"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "To ..."
    },
    domProps: {
      "value": (_vm.searchTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "categories-list-body__body"
  }, _vm._l((_vm.updatedRedirects), function(redirect, i) {
    return _c('tr', [(redirect.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding",
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v("\n            " + _vm._s(redirect.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (redirect.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(redirect.fromUrl) + "\n          ")]) : _vm._e(), _vm._v(" "), (redirect.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(redirect.toUrl) + "\n          ")]) : _vm._e(), _vm._v(" "), (redirect.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.switchEditMode(redirect.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (redirect.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center",
      staticStyle: {
        "width": "50px"
      }
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeRedirect(redirect.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (redirect.type === 'edit') ? _c('td', {
      staticClass: "edit-row chapter-edit",
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form"
    }, [_c('div', {
      staticClass: "row-edit-form"
    }, [_c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-from"
      }
    }, [_vm._v("Redirect from")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (redirect.fromUrl),
        expression: "redirect.fromUrl"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-from",
        "placeholder": "Type in redirect from"
      },
      domProps: {
        "value": (redirect.fromUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(redirect, "fromUrl", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "form-label color-2-63",
      attrs: {
        "for": "edit-to"
      }
    }, [_vm._v("Redirect to")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (redirect.toUrl),
        expression: "redirect.toUrl"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "id": "edit-to",
        "placeholder": "Type in redirect to"
      },
      domProps: {
        "value": (redirect.toUrl)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(redirect, "toUrl", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.discardChanges(redirect.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editRedirect(redirect.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Redirects")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc013112","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Redirects.vue
// module id = 1055
// module chunks = 0